import { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import Widget from "./components/Widget";
import useConfig from "./hooks/useConfig";
import useSocketConnection from "./hooks/useSocketConnection";
import { selectors as settingsSelectors } from "./state/settings";
import GlobalStyle from "./Style/globalStyle";
import { darkTheme, lightTheme } from "./Style/theme";

const App: FunctionComponent<{ id: string }> = ({ id }) => {
  const { darkMode, height } = useSelector(settingsSelectors.getAllSettings);
  const theme = darkMode ? darkTheme : lightTheme;

  useSocketConnection();
  useConfig();

  return (
    <ThemeProvider theme={theme}>
      {/* @ts-ignore */}
      <GlobalStyle theme={theme} widgetHeight={height} />
      <Widget />
    </ThemeProvider>
  );
};

export default App;
